export const sharedInitOptions = () => ({
	enabled: process.env.SENTRY_ENABLED === 'true',
	dsn: process.env.SENTRY_DSN || '',
	environment: process.env.NEXT_PUBLIC_ENVIRONMENT || 'development',
	sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE || '0.05'),
	tracesSampleRate: parseFloat(
		process.env.SENTRY_TRACES_SAMPLE_RATE || '0.025',
	),
})

export const replayOptions = () => ({
	replaysSessionSampleRate: parseFloat(
		process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '0.01',
	),
	replaysOnErrorSampleRate: parseFloat(
		process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '0.5',
	),
})
